var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    id: "Layer_1",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.334,3H25V1c0-0.553-0.447-1-1-1s-1,0.447-1,1v2h-6V1c0-0.553-0.448-1-1-1s-1,0.447-1,1v2H9V1   c0-0.553-0.448-1-1-1S7,0.447,7,1v2H2.667C1.194,3,0,4.193,0,5.666v23.667C0,30.806,1.194,32,2.667,32h26.667   C30.807,32,32,30.806,32,29.333V5.666C32,4.193,30.807,3,29.334,3z M30,29.333C30,29.701,29.701,30,29.334,30H2.667   C2.299,30,2,29.701,2,29.333V5.666C2,5.299,2.299,5,2.667,5H7v2c0,0.553,0.448,1,1,1s1-0.447,1-1V5h6v2c0,0.553,0.448,1,1,1   s1-0.447,1-1V5h6v2c0,0.553,0.447,1,1,1s1-0.447,1-1V5h4.334C29.701,5,30,5.299,30,5.666V29.333z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 3,
    width: 4,
    x: 7,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 3,
    width: 4,
    x: 7,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 3,
    width: 4,
    x: 7,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 3,
    width: 4,
    x: 14,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 3,
    width: 4,
    x: 14,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 3,
    width: 4,
    x: 14,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 3,
    width: 4,
    x: 21,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 3,
    width: 4,
    x: 21,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 3,
    width: 4,
    x: 21,
    y: 12
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4be6e75256c9393950dfa20d15a05c93.svg";
export { ForwardRef as ReactComponent };